// Fronted/src/services/adminService.js
import api from './api';

const adminService = {
  login: async (credentials) => {
    try {
      const response = await api.post('/admin/login', credentials);
      if (response.data.token) {
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminUser', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      console.error('Error logging in:', error);
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  },

  getCurrentAdmin: () => {
    const adminUser = localStorage.getItem('adminUser');
    return adminUser ? JSON.parse(adminUser) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('adminToken');
  },

  getDashboardStats: async () => {
    try {
      const response = await api.get('/admin/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  getUsers: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/admin/users?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  getUserById: async (id) => {
    try {
      const response = await api.get(`/admin/users/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching user ${id}:`, error);
      throw error;
    }
  },

  updateUser: async (id, userData) => {
    try {
      const response = await api.put(`/admin/users/${id}`, userData);
      return response.data;
    } catch (error) {
      console.error(`Error updating user ${id}:`, error);
      throw error;
    }
  },

  deleteUser: async (id) => {
    try {
      const response = await api.delete(`/admin/users/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting user ${id}:`, error);
      throw error;
    }
  },

  getPayments: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/admin/payments?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payments:', error);
      throw error;
    }
  },

  getPaymentById: async (id) => {
    try {
      const response = await api.get(`/admin/payments/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching payment ${id}:`, error);
      throw error;
    }
  },

  updatePaymentStatus: async (id, status) => {
    try {
      const response = await api.put(`/admin/payments/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error(`Error updating payment ${id} status:`, error);
      throw error;
    }
  },
  getAllEvents: async () => {
    try {
      const response = await api.get('/admin/events');
      return response.data;
    } catch (error) {
      console.error('Error fetching events:', error);
      throw error;
    }
  },

  getEventById: async (id) => {
    try {
      const response = await api.get(`/admin/events/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching event ${id}:`, error);
      throw error;
    }
  },

  createEvent: async (eventData) => {
    try {
      const response = await api.post('/admin/events', eventData);
      return response.data;
    } catch (error) {
      console.error('Error creating event:', error);
      throw error;
    }
  },

  updateEvent: async (id, eventData) => {
    try {
      const response = await api.put(`/admin/events/${id}`, eventData);
      return response.data;
    } catch (error) {
      console.error(`Error updating event ${id}:`, error);
      throw error;
    }
  },

  deleteEvent: async (id) => {
    try {
      const response = await api.delete(`/admin/events/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting event ${id}:`, error);
      throw error;
    }
  },

  // Sermon methods
  getAllSermons: async () => {
    try {
      const response = await api.get('/admin/sermons');
      return response.data;
    } catch (error) {
      console.error('Error fetching sermons:', error);
      throw error;
    }
  },

  getSermonById: async (id) => {
    try {
      const response = await api.get(`/admin/sermons/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching sermon ${id}:`, error);
      throw error;
    }
  },

  createSermon: async (sermonData) => {
    try {
      const response = await api.post('/admin/sermons', sermonData);
      return response.data;
    } catch (error) {
      console.error('Error creating sermon:', error);
      throw error;
    }
  },

  updateSermon: async (id, sermonData) => {
    try {
      const response = await api.put(`/admin/sermons/${id}`, sermonData);
      return response.data;
    } catch (error) {
      console.error(`Error updating sermon ${id}:`, error);
      throw error;
    }
  },

  deleteSermon: async (id) => {
    try {
      const response = await api.delete(`/admin/sermons/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting sermon ${id}:`, error);
      throw error;
    }
  },

  // Additional methods
  getSpeakers: async () => {
    try {
      const response = await api.get('/admin/speakers');
      return response.data;
    } catch (error) {
      console.error('Error fetching speakers:', error);
      throw error;
    }
  },

  getCampuses: async () => {
    try {
      const response = await api.get('/campuses');
      return response.data;
    } catch (error) {
      console.error('Error fetching campuses:', error);
      throw error;
    }
  }
};

export default adminService; 